import React, { FC } from 'react'
import { sentry } from '@chilipiper/config'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { ErrorBoundaryProps } from '@sentry/react/dist/errorboundary'
import { BrowserOptions } from '@sentry/react'

export function init(projectName: string, dsn: string, options: BrowserOptions = {}) {
  Sentry.init({
    dsn,
    debug: process.env.NODE_ENV === 'development',
    release: sentry.release,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.8,
    environment: sentry.env,
    autoSessionTracking: true,
    sampleRate: 0.8,
    ignoreErrors: [
      'TypeError: Failed to fetch',
      'TypeError: NetworkError when attempting to fetch resource.',
      'ResizeObserver loop limit exceeded', // https://stackoverflow.com/a/50387233/2652124
      ...(options.ignoreErrors || []),
    ],
    ...options,
  })

  Sentry.setTag('environment', sentry.env)
}

export const setUser = Sentry.setUser

export const setTag = Sentry.setTag

export const addBreadcrumb = Sentry.addBreadcrumb

export const captureException = Sentry.captureException

export const captureMessage = Sentry.captureMessage

export const withScope = Sentry.withScope

export const withProfiler = Sentry.withProfiler

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({ onError, ...props }) => (
  <Sentry.ErrorBoundary {...props} />
)
